import classes from "./Result.module.scss";
import Cards from '../../../Cards/Cards';


const Result = ()=> {
  return (
    <div className={classes.Result}>
      <Cards
       title={"То есть дальнейшее развитие сайта стало весьма проблематичным."}
       customClass={classes.Cards}
       customTitleClass={classes.CardsTitle}
      />
      <div className={classes.RightSide}>
        <p className={classes.Text}>В связи с этим нами был спроектирован новый сайт, основанный на анализе всех полученных за время работы данных и данных, полученных на основе анализа сайтов конкурентов. Запуск нового сайта планируется в 2021 году.</p>
        <p className={classes.Text}>Следующая масштабная задача – сохранить все наработки по трафику и конверсии на новом сайте.</p>
      </div>
    </div>
  )
}


export default Result;